class BeforeAfterComparison {
  constructor(container) {
    this.container = container;
    this.divider = container.querySelector('.before-after__divider');
    this.handle = container.querySelector('.before-after__handle');
    this.afterImage = container.querySelector('.before-after__image--after');
    this.isDragging = false;
    this.startX = 0;
    this.startLeft = 0;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.setInitialPosition();
  }
  
  bindEvents() {
    // Mouse events
    this.handle.addEventListener('mousedown', this.handleMouseDown.bind(this));
    document.addEventListener('mousemove', this.handleMouseMove.bind(this));
    document.addEventListener('mouseup', this.handleMouseUp.bind(this));
    
    // Touch events for mobile
    this.handle.addEventListener('touchstart', this.handleTouchStart.bind(this));
    document.addEventListener('touchmove', this.handleTouchMove.bind(this));
    document.addEventListener('touchend', this.handleTouchEnd.bind(this));
    
    // Keyboard events for accessibility
    this.handle.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.handle.setAttribute('tabindex', '0');
    this.handle.setAttribute('role', 'slider');
    this.handle.setAttribute('aria-label', 'Comparador antes e depois');
    this.handle.setAttribute('aria-valuemin', '0');
    this.handle.setAttribute('aria-valuemax', '100');
    this.handle.setAttribute('aria-valuenow', '50');
  }
  
  setInitialPosition() {
    this.updatePosition(50); // 50% = centro
  }
  
  handleMouseDown(e) {
    e.preventDefault();
    this.startDragging(e.clientX);
  }
  
  handleTouchStart(e) {
    e.preventDefault();
    const touch = e.touches[0];
    this.startDragging(touch.clientX);
  }
  
  startDragging(clientX) {
    this.isDragging = true;
    this.container.classList.add('dragging');
    this.startX = clientX;
    this.startLeft = this.getCurrentPosition();
    
    // Adicionar classe para cursor global
    document.body.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
  }
  
  handleMouseMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    this.updateFromClientX(e.clientX);
  }
  
  handleTouchMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    const touch = e.touches[0];
    this.updateFromClientX(touch.clientX);
  }
  
  handleMouseUp() {
    this.stopDragging();
  }
  
  handleTouchEnd() {
    this.stopDragging();
  }
  
  stopDragging() {
    this.isDragging = false;
    this.container.classList.remove('dragging');
    
    // Remover classes globais
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }
  
  handleKeyDown(e) {
    const step = 5; // 5% por tecla
    
    switch(e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        this.updatePosition(this.getCurrentPosition() - step);
        break;
      case 'ArrowRight':
        e.preventDefault();
        this.updatePosition(this.getCurrentPosition() + step);
        break;
      case 'Home':
        e.preventDefault();
        this.updatePosition(0);
        break;
      case 'End':
        e.preventDefault();
        this.updatePosition(100);
        break;
    }
  }
  
  updateFromClientX(clientX) {
    const rect = this.container.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    this.updatePosition(percentage);
  }
  
  updatePosition(percentage) {
    // Limitar entre 0% e 100%
    percentage = Math.max(0, Math.min(100, percentage));
    
    // Usar requestAnimationFrame para melhor performance
    requestAnimationFrame(() => {
      // Atualizar posição do divisor
      this.divider.style.left = percentage + '%';
      this.handle.style.left = percentage + '%';
      
      // Atualizar clip-path da imagem "depois"
      this.afterImage.style.clipPath = `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`;
      
      // Atualizar aria-valuenow para acessibilidade
      this.handle.setAttribute('aria-valuenow', Math.round(percentage));
    });
  }
  
  getCurrentPosition() {
    const left = parseFloat(this.divider.style.left);
    return isNaN(left) ? 50 : left;
  }
  
  destroy() {
    // Remover event listeners
    this.handle.removeEventListener('mousedown', this.handleMouseDown);
    this.handle.removeEventListener('touchstart', this.handleTouchStart);
    this.handle.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.removeEventListener('touchend', this.handleTouchEnd);
  }
}

// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.before-after-container');
  
  containers.forEach(container => {
    new BeforeAfterComparison(container);
  });
});

// Suporte para Shopify Sections
if (typeof theme !== 'undefined' && theme.Sections) {
  theme.Sections.register('before-after-comparison', {
    onSectionLoad: function(container) {
      const beforeAfterContainer = container.querySelector('.before-after-container');
      if (beforeAfterContainer) {
        new BeforeAfterComparison(beforeAfterContainer);
      }
    },
    
    onSectionUnload: function(container) {
      // Cleanup será feito automaticamente pelo garbage collector
    }
  });
}
